<template>

  <!-- Page Breadcrumbs -->
  <q-breadcrumbs
    v-if="items.length"
    class="page-breadcrumbs">

    <q-breadcrumbs-el
      :to="item.to"
      :key="index + item.to"
      class="page-breadcrumbs__item"
      v-for="(item, index) in items"
      :label="$u.localize(item.label)"/>

  </q-breadcrumbs>

</template>

<script>

  import {mapGetters} from 'vuex';

  export default {
    name: 'page-breadcrumbs',
    props: {
      title: {
        type: [String, Object],
        default: '',
      },
    },
    computed: {
      ...mapGetters('page', {
        items: 'breadcrumbs',
      }),
    },
  };

</script>

<style lang="scss">

  .page-breadcrumbs {
    margin-bottom: $spacer-md;

    &__item {
      color: $link-color;
      pointer-events: all;
      text-decoration: underline;
    }

    .q-breadcrumbs--last a {
      color: $grey-6;
      text-decoration: none;
    }

    @media (max-width: $breakpoint-xs) {

      .q-breadcrumbs__separator:nth-last-child(2) {
        display: none;
      }

      .q-breadcrumbs--last a {
        display: none;
      }
    }
  }

</style>
